var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CarouselSlide',{staticClass:"ukasko-slide"},[_c('FeaturesList',{staticClass:"ukasko-slide__list",attrs:{"title":"Стало з UConnect","list-type":"fancy","items":_vm.getUkaskoItems,"image-components":_vm.getUkaskoItemsImageComponents}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }